import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchCredentials } from "../services/api";
import { useAuth } from "./AuthContext";

const CredentialsContext = createContext({
    credentials: [],
    setCredentials: () => {},
    loading: false,
    error: null,
    refresh: () => {},
});

export const CredentialsProvider = ({ children }) => {
    const [credentials, setCredentials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { authEnabled, loading: authLoading, user } = useAuth();

    const loadCredentials = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await fetchCredentials();
            setCredentials(Array.isArray(data) ? data : []);
        } catch (err) {
            setError(err);
            setCredentials([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (authEnabled && (authLoading || !user)) {
            setCredentials([]);
            setLoading(authLoading);
            return;
        }
        loadCredentials();
    }, [authEnabled, authLoading, loadCredentials, user]);

    return (
        <CredentialsContext.Provider
            value={{ credentials, setCredentials, loading, error, refresh: loadCredentials }}
        >
            {children}
        </CredentialsContext.Provider>
    );
};

export const useCredentialsContext = () => useContext(CredentialsContext);

export default CredentialsContext;
